import React from "react"

export const LoadingButton = () => {
    return <span><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        <span className="sr-only">Loading...</span></span>
}